import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as myGlobals from '../../globals';
import { ConfigService } from '../../config.service';


export class User {
    constructor(private _cookie: ConfigService) { }
}

@Injectable()
export class AccountService {

    private _updateprofile = myGlobals.apiurl + 'profile/me';
    private _checkprofile = myGlobals.apiurl + 'profile/me';
    private _checkpassword = myGlobals.apiurl + 'checkpassword';

    // START OF UBER FOR ALL API CALLS

    private _changeEmail = myGlobals.apiurl + 'dispatcher/email';
    private _changePassword = myGlobals.apiurl + 'dispatcher/password/me';
    private _changePhonenum = myGlobals.apiurl + 'dispatcher/phoneNumber';
    private _changeFirstName = myGlobals.apiurl + 'dispatcher/profile';
    private _checkPhone = myGlobals.apiurl + 'dispatcher/phoneValidation';
    private _otpresend = myGlobals.apiurl + 'dispatcher/resendOtp';
    private _profile = myGlobals.apiurl + 'dispatcher/profile';
    private _signotp = myGlobals.apiurl + 'dispatcher/verifyVerificationCode';
    // END OF UBER FOR ALL API CALLS

    constructor(
        private _router: Router,
        private _http: HttpClient,
        private _cookie: ConfigService
    ) { }

    // START OF UBER FOR ALL FUNCTIONS

    // change email
    changeEmail(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changeEmail, body, { headers: this._cookie.header });
    }

    // change email
    getProfile(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.get(this._profile, { headers: this._cookie.header });
    }



    // change password
    changePassword(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changePassword, body, { headers: this._cookie.header });
    }

    // change password
    changePhoneNum(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changePhonenum, body, { headers: this._cookie.header });
    }

    // change first name
    changeFirstName(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changeFirstName, body, { headers: this._cookie.header });
    }

    // END OF UBER FOR ALL FUNCTIONS

    // PROFILE CHANGING CALL 
    updateprofile(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.put(this._updateprofile, body, { headers: this._cookie.header });
    }

    // CHECK PASSWORD CALL 
    checkpassword(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.post(this._checkpassword, body, { headers: this._cookie.header });
    }

    //resend otp
    signupotpresend(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._otpresend, body, { headers: this._cookie.header });
    }

    // CHECK PHONENUMBER CALL 
    checkPhone(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.post(this._checkPhone, body, { headers: this._cookie.header });
    }

    // SIGNUP OTP

    signupotp(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._signotp, body, { headers: this._cookie.header });
    }
}